export class IngestionPipelineDeadLetterSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "failedFiles",
            "baseName": "failedFiles",
            "type": "number",
            "format": ""
        },
        {
            "name": "filesRead",
            "baseName": "filesRead",
            "type": "number",
            "format": ""
        },
        {
            "name": "scanTruncated",
            "baseName": "scanTruncated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<IngestionPipelineDeadLetterErrorGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineDeadLetterSummary.attributeTypeMap;
    }
    constructor() {
    }
}
